module.exports = __webpack_public_path__ + "static/img/dataweb.15a73d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dataweb.jpg
// module id = x2EO
// module chunks = 1